module.exports = __webpack_public_path__ + "static/media/12UNCTAD11.b7179e98.jpg";